export default __webpack_public_path__ + "static/media/dreamsbrows_logo.5190f74b.png";